import React from 'react';
import { CircleDollarSign, Clock, ShieldCheck, Users } from 'lucide-react';
import i18n from '../i18n/config';

const Features: React.FC = () => {
  return (
    <section className="py-24 bg-[#f9fafb]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#2c3e50] mb-4">{i18n.t('features.title')}</h2>
          <p className="text-xl text-[#2c3e50]/80 max-w-2xl mx-auto">{i18n.t('features.description')}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-white p-8 border border-[#3498db]/30 hover:border-[#3498db] hover:shadow-lg transition-all duration-300 group">
            <div className="text-[#3498db] mb-6 group-hover:scale-110 transition-transform duration-300">
              <CircleDollarSign size={40} />
            </div>
            <h3 className="text-2xl font-semibold text-[#2c3e50] mb-4">{i18n.t('features.quick_approval.title')}</h3>
            <p className="text-[#2c3e50]/80 leading-relaxed">{i18n.t('features.quick_approval.description')}</p>
          </div>
          
          <div className="bg-white p-8 border border-[#1abc9c]/30 hover:border-[#1abc9c] hover:shadow-lg transition-all duration-300 group">
            <div className="text-[#1abc9c] mb-6 group-hover:scale-110 transition-transform duration-300">
              <Clock size={40} />
            </div>
            <h3 className="text-2xl font-semibold text-[#2c3e50] mb-4">{i18n.t('features.flexible_terms.title')}</h3>
            <p className="text-[#2c3e50]/80 leading-relaxed">{i18n.t('features.flexible_terms.description')}</p>
          </div>
          
          <div className="bg-white p-8 border border-[#f1c40f]/30 hover:border-[#f1c40f] hover:shadow-lg transition-all duration-300 group">
            <div className="text-[#f1c40f] mb-6 group-hover:scale-110 transition-transform duration-300">
              <ShieldCheck size={40} />
            </div>
            <h3 className="text-2xl font-semibold text-[#2c3e50] mb-4">{i18n.t('features.secure_process.title')}</h3>
            <p className="text-[#2c3e50]/80 leading-relaxed">{i18n.t('features.secure_process.description')}</p>
          </div>
          
          <div className="bg-white p-8 border border-[#3498db]/30 hover:border-[#3498db] hover:shadow-lg transition-all duration-300 group">
            <div className="text-[#3498db] mb-6 group-hover:scale-110 transition-transform duration-300">
              <Users size={40} />
            </div>
            <h3 className="text-2xl font-semibold text-[#2c3e50] mb-4">{i18n.t('features.personal_support.title')}</h3>
            <p className="text-[#2c3e50]/80 leading-relaxed">{i18n.t('features.personal_support.description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features; 